/* import __COLOCATED_TEMPLATE__ from './tempco.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();